module.exports = __webpack_public_path__ + "img/banner2.72c898d0.png";